import { render, staticRenderFns } from "./AFitText.vue?vue&type=template&id=3c34a506&"
import script from "./AFitText.vue?vue&type=script&lang=js&"
export * from "./AFitText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports